// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hf-0";